import * as yup from "yup";

const attributeFilterObjectShape = yup.object().shape({
  type: yup.string().required("Attribute value is required"),
  weight: yup.number().required("Attribute weight is required").min(0.01, "Min weight is 0.01"),
});

export default attributeFilterObjectShape;
